import { withBrowserTextareaHeight } from '@/src/general/utils/withBrowserTextareaHeight'

import { WatchmanPrayFlowThankStep as WatchmanPrayFlowThankStepNative } from './WatchmanPrayFlowThankStep.shared'

export const WatchmanPrayFlowThankStep = withBrowserTextareaHeight(WatchmanPrayFlowThankStepNative)
